<div class="bg-card-light dark:bg-card-dark p-6 rounded-xl border border-gray-200 dark:border-gray-800 shadow-sm">
  <h3 class="text-lg font-bold font-display text-gray-700 dark:text-white mb-4">Recently Uploaded Documents</h3>
  <ul *ngIf="documents.length > 0; else noDocuments" class="space-y-3">
    <li *ngFor="let doc of documents" class="flex items-center gap-3 group cursor-pointer" (click)="openDocument(doc)">
      <span class="material-symbols-outlined text-secondary">description</span>
      <div class="flex-1">
        <p class="text-sm text-gray-700 dark:text-gray-300 group-hover:text-primary dark:group-hover:text-primary transition-colors truncate">
          <span class="font-semibold">{{ doc.application }}:</span> {{ doc.title }}
        </p>
        <p class="text-xs text-gray-400 dark:text-gray-500">Uploaded: {{ doc.uploaded }}</p>
      </div>
      <span *ngIf="doc.isNew" class="px-2 py-0.5 rounded-full bg-success/20 text-success text-xs font-medium">New</span>
    </li>
  </ul>
  <ng-template #noDocuments>
    <p class="text-sm text-gray-500 dark:text-gray-400">
      No recent documents uploaded.
    </p>
  </ng-template>
</div>